import { z } from 'zod/v4';
export enum Directives {
  ROUTE = 'route',
  REFRESH = 'refresh',
}
const routeDataSchema = z.object({
  directive: z.literal(Directives.ROUTE),
  routing: z.object({
    entity_index: z.number(),
    step_id: z.string(),
  }),
});

const refreshDataSchema = z.object({
  directive: z.literal(Directives.REFRESH),
  message: z.string().nullable().optional(),
});

export const actionDataSchema = z.discriminatedUnion('directive', [routeDataSchema, refreshDataSchema]);
export type ActionData = z.infer<typeof actionDataSchema>;
